<template>
  <div>
    <v-container
      v-show="!Loading"
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title> Dashboard </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />

      <v-container>
        <v-row>
          <v-col cols="12" sm="4" class="pa-0">
            <v-hover v-slot:default="{ hover }">
              <v-card
                height="160"
                class="d-flex align-center ma-1"
                :elevation="hover ? 18 : undefined"
                :style="{
                  transform: hover ? 'translateY(-10px)' : undefined,
                  transition: hover ? 'transform .2s ease-in-out' : undefined,
                }"
              >
                <v-container>
                  <div class="d-flex flex-column">
                    <v-card class="pa-2 d-flex justify-center" flat>
                      <v-avatar color="transparent" tile>
                        <img width="50" src="@/assets/img/pp.svg" alt="" />
                      </v-avatar>
                    </v-card>
                    <v-card class="pa-2 d-flex justify-center text-center" flat>
                      <h5>
                        {{
                          general.surveyStatus
                            ? "เปิดการใช้งานเมื่อ"
                            : general.highActionAmount === 0
                            ? "สร้างแบบสอบถามเมื่อ"
                            : "ปิดการใช้งานเมื่อ"
                        }}
                        <br />
                        {{
                          general.launchDate
                            ? $store.getters.datetimeConvert(general.launchDate)
                            : "-"
                        }}
                      </h5>
                    </v-card>
                  </div>
                </v-container>
              </v-card>
            </v-hover>
          </v-col>
          <v-col cols="12" sm="4" class="pa-0">
            <v-hover v-slot:default="{ hover }"
              ><v-card
                height="160"
                class="d-flex align-center ma-1"
                :elevation="hover ? 18 : undefined"
                :style="{
                  transform: hover ? 'translateY(-10px)' : undefined,
                  transition: hover ? 'transform .2s ease-in-out' : undefined,
                }"
              >
                <v-container>
                  <div class="d-flex flex-column">
                    <v-card class="pa-2 mb-0 d-flex justify-center" flat>
                      <v-avatar color="transparent" tile>
                        <v-icon size="50" color="#033666">quiz</v-icon>
                      </v-avatar>
                    </v-card>
                    <v-card class="pa-2 d-flex justify-center text-center" flat>
                      <h5>
                        {{ general.surveySuccess }} <br />
                        จำนวนการทำแบบสอบถามสำเร็จ
                      </h5>
                    </v-card>
                  </div>
                </v-container>
              </v-card></v-hover
            ></v-col
          >
          <v-col cols="12" sm="4" class="pa-0"
            ><v-hover v-slot:default="{ hover }"
              ><v-card
                height="160"
                class="d-flex align-center ma-1"
                :elevation="hover ? 18 : undefined"
                :style="{
                  transform: hover ? 'translateY(-10px)' : undefined,
                  transition: hover ? 'transform .2s ease-in-out' : undefined,
                }"
              >
                <v-container>
                  <div class="d-flex flex-column">
                    <v-card class="pa-2 d-flex justify-center" flat>
                      <v-avatar color="transparent" rounded>
                        <v-icon size="50" color="#D69120">schedule</v-icon>
                      </v-avatar>
                    </v-card>
                    <v-card class="pa-2 d-flex justify-center text-center" flat>
                      <h5>
                        แบบสอบถามที่ทำสำเร็จล่าสุด <br />
                        {{
                          general.latestResponse
                            ? general.highActionAmount === 0
                              ? "ยังไม่มีผู้ทำแบบสอบถาม"
                              : $store.getters.datetimeConvert(
                                  general.latestResponse
                                )
                            : "-"
                        }}
                      </h5>
                    </v-card>
                  </div>
                </v-container>
              </v-card></v-hover
            ></v-col
          >
          <v-col cols="12" class="pa-0 mt-2"
            ><v-card
              height="50"
              flat
              class="d-flex justify-end align-center text-center"
              color="transparent"
            >
              <div>
                <v-icon class="mr-2" color="#033666">mdi-eye-outline</v-icon
                >จำนวนการทำแบบสอบถามทั้งหมด:
                {{ general.surveyAction }}
              </div>
              <div
                v-if="
                  !(general.highActionAmount === 0 && !general.surveyStatus)
                "
              >
                <v-icon class="ml-2" color="#28760C">mdi-timer-sand</v-icon>
                เปิดใช้งานเป็นเวลา:
                {{
                  general.launchDate
                    ? $store.getters.DateDiffToday(general.launchDate)
                    : "-"
                }}
                วัน
              </div>
              <div>
                <v-icon class="ml-2" color="#D69120">question_answer</v-icon>
                แบบสอบถามที่สำเร็จวันนี้: {{ general.surveyToday }}
              </div></v-card
            ></v-col
          >
        </v-row>
      </v-container>

      <br />
      <v-card
        class="py-3 px-2"
        :class="[
          !$vuetify.breakpoint.mobile
            ? 'd-flex justify-space-between'
            : undefined,
        ]"
      >
        <v-card flat>
          <img
            src="https://chatme04.chatme.co.th/CMStorage/overview1626159599766.png"
            alt=""
            width="240"
          />
        </v-card>
        <v-card height="200" class="d-flex align-center" flat>
          <v-container>
            <div class="d-flex flex-column">
              <v-card class="pa-2 d-flex justify-start" flat>
                สถานะ:
                <span
                  class="justify-start mx-2"
                  :class="[general.surveyStatus ? 'green--text' : 'red--text']"
                  >{{
                    general.surveyStatus ? "เปิดการใช้งาน" : "ปิดการใช้งาน"
                  }}</span
                >
              </v-card>
              <v-card class="pa-2 d-flex justify-start" flat>
                วันที่จำนวนการทำแบบสอบถามมากที่สุด:
                {{
                  general.highActionDate
                    ? general.highActionAmount === 0
                      ? "ยังไม่มีผู้ทำแบบสอบถาม"
                      : $store.getters.dateConvert(general.highActionDate)
                    : "-"
                }}
              </v-card>
              <v-card class="pa-2 d-flex justify-start" flat>
                จำนวนการตอบแบบสอบถามสูงสุด :
                {{ general.highActionAmount }} ครั้ง/วัน
              </v-card>
              <v-card class="pa-2 d-flex justify-start" flat>
                จำนวนคำถามทั้งหมด: {{ general.allQuestion }} ข้อ
              </v-card>
            </div>
          </v-container>
        </v-card>
      </v-card>
      <br />
      <br />
      <v-row no-gutters>
        <v-col cols="12" md="5"></v-col>
        <v-col cols="12" md="7" class="d-flex align-center">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="ThaiDate(date)"
                label="เลือกวันที่จะดู"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              scrollable
              range
              no-title
              :max="today"
            >
              <v-spacer></v-spacer>
              <v-btn text color="#033666" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="#033666" @click="DateRange"> OK </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-card
        flat
        color="transparent"
        class="d-flex justify-end align-center mb-4"
      >
        <v-row>
          <v-col cols="6" class="d-flex align-center" style="color: #395da5"
            ><h3>Report</h3></v-col
          >
          <v-col cols="12" sm="4" class="d-flex align-center"
            ><v-text-field
              v-model="search"
              solo
              dense
              hide-details
              class="rounded-pill"
            >
              <template #label
                ><v-icon>mdi-magnify</v-icon
                ><span style="font-size: 12px">Search</span>
              </template>
            </v-text-field></v-col
          >
          <v-col
            cols="12"
            sm="2"
            class="d-flex align-center"
            v-if="RPermission.download"
          >
            <v-btn
              color="#033666"
              class="mx-2 white--text"
              @click="exportsurvey"
              ><span style="font-size: 12px">Export</span>
              <v-icon small class="ml-2">mdi-file-excel</v-icon>
            </v-btn></v-col
          >
        </v-row>
      </v-card>

      <v-card class="py-3 px-6">
        <v-data-table
          :sort-by="['time']"
          :sort-desc="[true]"
          :headers="DataHeader"
          :items="items"
          :search="search"
        >
        </v-data-table>
      </v-card>
      <v-card flat color="transparent" class="d-flex justify-end mt-2">
        <AdvandCal :Alldata="items" :storeQuestion="storeQuestion" />
      </v-card>
      <br />
      <br />
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title primary-title
              ><v-spacer></v-spacer>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#033666"
                    class="mx-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span style="font-size: 12px"> Chart</span>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in socialsummarychart"
                    :key="index"
                    @click="SummartSocialChartChange(item)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <Pie
                v-if="socialsummarychart_selected === 'pie'"
                title="Social summary"
                :data="socialsummary"
              />
              <SingleBarChart
                v-if="socialsummarychart_selected === 'column'"
                title="Social summary"
                :data="socialsummary"
              />
            </v-card-text> </v-card
        ></v-col>
      </v-row>
      <br />
      <v-card>
        <v-card-title primary-title
          ><v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
                <span style="font-size: 12px">Chart</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in chart"
                :key="index"
                @click="ChartChange(item)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <BasicChart :data="userperday" />
          <!-- <NormalBasicChart :data="userperday"/> -->
        </v-card-text>
      </v-card>
      <br />
      <v-card>
        <v-card-title primary-title
          ><v-spacer></v-spacer
          ><v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
                <span style="font-size: 12px">Social</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in social"
                :key="index"
                @click="getUserHeatmap(item.value)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <Heatmap :data="heatmap" />
        </v-card-text>
      </v-card>
      <br />
      <v-card>
        <v-card-title primary-title
          ><v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
                <span style="font-size: 12px"> Social</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in social"
                :key="index"
                @click="
                  getSummaryScore(item.value), getBoxplotScore(item.value)
                "
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
                <span style="font-size: 12px"> Chart</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in scorechart"
                :key="index"
                @click="ScoreChartChange(item)"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <Pie
            v-if="scorechart_selected === 'pie'"
            title="Summary score"
            :data="piescore"
          />
          <SingleBarChart
            v-if="scorechart_selected === 'column'"
            title="Summary score"
            :data="piescore"
          />
          <BoxPlot
            v-if="scorechart_selected === 'boxplot'"
            :data="boxplotscore"
          />
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Pie from "../../components/Dashboard/Chart/Pie";
import SingleBarChart from "../../components/Dashboard/Chart/SingleBarChart.vue";
import BasicChart from "../../components/Dashboard/Chart/BasicChart";
// import NormalBasicChart from "../../components/Dashboard/Chart/NormalBasicChart.vue";
import Heatmap from "../../components/Dashboard/Chart/Heatmap";
import BoxPlot from "../../components/Dashboard/Chart/BoxPlot";
import AdvandCal from "./AdvandCal.vue";
import Swal from "sweetalert2";
export default {
  components: { Pie, BasicChart, Heatmap, BoxPlot, SingleBarChart, AdvandCal },
  data() {
    return {
      date: [
        new Date(new Date().setDate(new Date().getDate() - 15))
          .toISOString()
          .substring(0, 10),
        new Date().toISOString().substring(0, 10),
      ],
      today: new Date().toISOString().substr(0, 10),
      modal: false,
      shortcut: [],
      social: [
        { title: "All", value: "ALL" },
        { title: "Facebook", value: "FACEBOOK" },
        { title: "Line", value: "LINE" },
        { title: "OneChat", value: "ONECHAT" },
        { title: "Webform", value: "webform" },
      ],
      chart: [
        { title: "Line Chart", value: "line" },
        { title: "Bar Chart", value: "column" },
        { title: "Stacked Column", value: "stacked" },
      ],
      scorechart_selected: "pie",
      scorechart: [
        { title: "Pie Chart", value: "pie" },
        { title: "Bar Chart", value: "column" },
        { title: "Box plot", value: "boxplot" },
      ],
      socialsummarychart_selected: "pie",
      socialsummarychart: [
        { title: "Pie Chart", value: "pie" },
        { title: "Bar Chart", value: "column" },
      ],
      general: {
        launchDate: "",
        surveyStatus: false,
        allQuestion: 0,
        surveyAction: 0,
        surveySuccess: 0,
        latestResponse: "",
        surveyToday: 0,
        highActionDate: "",
        highActionAmount: 0,
      },
      socialsummary: {
        pointFormat: "{point.name}: <b>{point.y} ครั้ง</b>",
        colors: [],
        data: [
          {
            name: "Social",
            colorByPoint: true,
            data: [],
          },
        ],
      },
      userperday: {
        stacking: false,
        title: {
          text: "User per day",
        },
        subtitle: {
          text: "",
        },
        colors: [],
        tooltip: {
          headerFormat: "",
          pointFormat: "{series.name}: {point.y}",
        },
        data: [],
      },
      piescore: {
        pointFormat: "{point.name}: <b>{point.y} ครั้ง</b>",
        colors: [],
        data: [
          {
            name: "Score",
            colorByPoint: true,
            data: [],
          },
        ],
      },
      boxplotscore: {
        title: {
          text: "Summary score",
        },
        subtitle: {
          text: "",
        },
        daterange: [],
        data: [],
      },
      heatmap: {
        title: {
          text: "User per hour",
        },
        subtitle: {
          text: "",
        },
        xAxis: [],
        yAxis: [],
        data: [],
      },
      items: [],
      search: "",
    };
  },
  created() {
    this.$vuetify.goTo(0, {
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
    });
    this.DashboardOverview();
  },
  computed: {
    RPermission() {
      return this.$store.state.user_permission.report;
    },
    Loading() {
      return this.$store.state.loading;
    },
    DataHeader() {
      let headers = [
        {
          text: "วัน เวลา",
          value: "time",
          width: 170,
        },
        {
          text: "UserID",
          value: "userID",
          width: 120,
        },
        {
          text: "Account",
          value: "username",
          width: 120,
        },
        
      ];
      this.storeQuestion.map((q, i) => {
        headers.push({
          text: q.questionLabel,
          value: q.questionID,
          width: 170,
        });
        if (i === this.storeQuestion.length - 1) {
          headers.push({
            text: "คะแนน",
            value: "score",
            width: 90,
          });
        }
      });
      return headers;
    },
    storeQuestion() {
      let allquestion = this.$store.state.allquestion;
      let connect = [];
      allquestion.map((question) => {
        if (
          question.questionType === "connect" ||
          question.questionType === "start"
        ) {
          connect.push(question);
        }
      });
      connect.sort(function (a, b) {
        return a.indexing - b.indexing;
      });
      return connect;
    },
  },
  methods: {
    DashboardOverview() {
      this.$store.dispatch("CheckPermission").then(async (resp_role) => {
        if (resp_role.data.permission) {
          if (Object.keys(resp_role.data.permission).length !== 0) {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            if (resp_role.data.permission.report.view) {
              await this.$store.commit("ToggleLoading");
              await this.getGeneral();
              await this.getSocialSummaryPie();
              await this.getSocialSummaryBasic();
              await this.getUserHeatmap("ALL");
              await this.getSummaryScore("ALL");
              await this.getBoxplotScore("ALL");
              await this.getReportAnswer("ALL");
              await this.$store.commit("ToggleLoading");
            } else {
              Swal.fire({
                icon: "error",
                text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
                title: "",
              }).then(() => {
                this.$router.push({
                  name: "question",
                });
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              this.$router.push({
                name: "question",
              });
            });
          }
        }
      });
    },
    getGeneral() {
      this.$store
        .dispatch("DashboardGeneral")
        .then((response) => {
          this.general = response;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGeneral)",
              title: "",
            });
          }
        });
    },
    getSocialSummaryPie() {
      this.$store
        .dispatch("DashboardSocialSummaryPie", this.date)
        .then((response) => {
          let colorkeys = {
            ONECHAT: "#033666",
            LINE: "#06c755",
            FACEBOOK: "#4267B2",
            webform: "#BBDEFB",
          };
          this.socialsummary.data[0].data = [];
          response.sort(function (a, b) {
            return a.socialType - b.socialType;
          });
          response.map((d) => {
            this.socialsummary.colors.push(colorkeys[d.socialType]);
            this.socialsummary.data[0].data.push({
              name: d.socialType,
              y: d.value,
            });
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            text: "ไม่สามารถดูข้อมูลได้ (DashboardSocialSummaryPie)",
            title: "",
          });
        });
    },
    getSocialSummaryBasic() {
      this.$store
        .dispatch("DashboardSocialSummaryBasic", this.date)
        .then((response) => {
          let tempdata = [];
          // console.log("ssbasic", response);
          let colorkeys = {
            ONECHAT: "#033666",
            LINE: "#06c755",
            FACEBOOK: "#4267B2",
            webform: "#BBDEFB",
          };
          response.sort(function (a, b) {
            return a.socialType - b.socialType;
          });
          response.map((d) => {
            this.userperday.colors.push(colorkeys[d.socialType]);
            tempdata.push({
              name: d.socialType,
              data: d.value,
              type: "column",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
            });
          });
          this.userperday.data = tempdata;
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            text: "ไม่สามารถดูข้อมูลได้ (DashboardSocialSummaryBasic)",
            title: "",
          });
        });
    },
    getUserHeatmap(social) {
      this.$store
        .dispatch("DashboardUserHeatmap", {
          social: social,
          daterange: this.date,
        })
        .then((response) => {
          this.heatmap.xAxis = response.xAxis;
          this.heatmap.yAxis = response.yAxis;
          this.heatmap.data = response.data;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardUserHeatmap)",
              title: "",
            });
          }
        });
    },
    getSummaryScore(social) {
      this.$store
        .dispatch("DashboardSummaryScore", {
          social: social,
          daterange: this.date,
        })
        .then((response) => {
          // console.log(response);
          this.piescore.data[0].data = [];
          response.sort(function (a, b) {
            return b.score - a.score;
          });
          response.map((d) => {
            this.piescore.data[0].data.push({
              name: `${d.score} คะแนน`,
              y: d.value,
            });
          });
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardSummaryScore)",
              title: "",
            });
          }
        });
    },
    getBoxplotScore(social) {
      this.$store
        .dispatch("DashboardBoxplotScore", {
          social: social,
          daterange: this.date,
        })
        .then((response) => {
          this.boxplotscore.data = response.data;
          this.boxplotscore.daterange = response.daterange;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardBoxplotScore)",
              title: "",
            });
          }
        });
    },
    ChartChange(chart) {
      if (chart.value === "stacked") {
        this.userperday.data.map((m) => {
          m.type = "column";
        });
        this.userperday.stacking = true;
        this.userperday.tooltip = {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat:
            "{series.name}: {point.y} ({point.percentage:.1f} %)<br/>Total: {point.stackTotal}",
        };
      } else {
        this.userperday.data.map((m) => {
          m.type = chart.value;
        });
        this.userperday.stacking = false;
        this.userperday.tooltip = {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y}<br/>",
        };
      }
    },
    ScoreChartChange(chart) {
      switch (chart.value) {
        case "pie":
          {
            this.scorechart_selected = "pie";
          }

          break;
        case "column":
          {
            this.scorechart_selected = "column";
          }

          break;
        case "boxplot":
          {
            this.scorechart_selected = "boxplot";
          }

          break;
      }
    },
    SummartSocialChartChange(chart) {
      switch (chart.value) {
        case "pie":
          {
            this.socialsummarychart_selected = "pie";
          }

          break;
        case "column":
          {
            this.socialsummarychart_selected = "column";
          }

          break;
      }
    },
    PlusDay(dayadd) {
      var result = new Date(this.dateExpirePackage);
      result.setDate(result.getDate() + dayadd);
      this.dateExpirePackage = result.toISOString().substring(0, 10);
    },
    PlusMonth(monthadd) {
      let d = new Date(this.dateExpirePackage);
      let lastdayofmonth = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      if (d.getDate() === lastdayofmonth.getDate()) {
        let last = new Date(d.getFullYear(), d.getMonth() + 1 + monthadd, 0);
        let day = last.getDate();
        let month =
          last.getMonth() + 1 < 10
            ? `0${last.getMonth() + 1}`
            : last.getMonth() + 1;
        let year = last.getFullYear();
        this.dateExpirePackage = `${year}-${month}-${day}`;
      } else {
        let nextdate = new Date(d.setMonth(d.getMonth() + monthadd));
        d = new Date(this.dateExpirePackage);
        if (d.getMonth() + monthadd === nextdate.getMonth()) {
          this.dateExpirePackage = new Date(
            new Date(this.dateExpirePackage).setMonth(
              new Date(this.dateExpirePackage).getMonth() + monthadd
            )
          )
            .toISOString()
            .substring(0, 10);
        } else {
          let last = new Date(nextdate.setDate(0));
          let day = last.getDate();
          let month =
            last.getMonth() + 1 < 10
              ? `0${last.getMonth() + 1}`
              : last.getMonth() + 1;
          let year = last.getFullYear();
          this.dateExpirePackage = `${year}-${month}-${day}`;
        }
      }
    },
    DateRange() {
      this.$refs.dialog.save(this.date);
      if (this.date.length > 1) {
        this.date.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });
      } else {
        this.date.push(this.date[0]);
      }
      this.$store.dispatch("CheckPermission").then((resp_role) => {
        if (resp_role.data.permission) {
          if (Object.keys(resp_role.data.permission).length !== 0) {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            if (resp_role.data.permission.report.view) {
              this.$store.dispatch("checkPackage").then(async () => {
                await this.getGeneral();
                await this.getSocialSummaryPie();
                await this.getSocialSummaryBasic();
                await this.getUserHeatmap("ALL");
                await this.getSummaryScore("ALL");
                await this.getBoxplotScore("ALL");
                await this.getReportAnswer("ALL");
              });
              this.modal = false;
            } else {
              Swal.fire({
                icon: "error",
                text: "สิทธิ์ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                this.$router.push({
                  name: "question",
                });
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              this.$router.push({
                name: "question",
              });
            });
          }
        }
      });
    },
    ThaiDate(array) {
      let arrayModify = JSON.parse(JSON.stringify(array));
      if (arrayModify.length > 1) {
        arrayModify.sort(function (a, b) {
          return new Date(a) - new Date(b);
        });
      }
      let convert = [];
      for (const key in arrayModify) {
        const element = arrayModify[key];
        convert.push(this.$store.getters.dateConvert(element));
      }
      return convert.join(" ~ ");
    },
    getReportAnswer(social) {
      this.$store
        .dispatch("DashboardReport", {
          social: social,
          daterange: this.date,
        })
        .then((response) => {
          this.items = response;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardReport)",
              title: "",
            });
          }
        });
    },
    exportsurvey() {
      if (this.items.length) {
        this.$store.dispatch("CheckPermission").then((resp_role) => {
          if (resp_role.data.permission) {
            if (Object.keys(resp_role.data.permission).length !== 0) {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              if (resp_role.data.permission.report.download) {
                this.$store.dispatch("checkPackage").then(() => {
                  let filename = `Survey_${new Date()
                    .toISOString()
                    .substr(0, 10)}`;
                  let exportdata = [];
                  let datatoexport = JSON.parse(JSON.stringify(this.items));
                  datatoexport.map((ans) => {
                    let temp = {};
                    for (const key in this.DataHeader) {
                      const element = this.DataHeader[key];
                      if (!ans[element.value] && ans[element.value] !== 0) {
                        temp[element.text] = "";
                      } else {
                        temp[element.text] = ans[element.value];
                      }
                    }
                    exportdata.push(temp);
                  });
                  this.JSONToCSVConvertor(exportdata, filename, true);
                });
              } else {
                Swal.fire({
                  icon: "error",
                  text: "สิทธิ์การ export ของคุณถูกปฏิเสธ",
                  title: "",
                }).then(() => {
                  this.$router.push({
                    name: "question",
                  });
                });
              }
            } else {
              Swal.fire({
                icon: "error",
                text: "สิทธิ์การ export ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                this.$store.commit("UpdateUserPermission", resp_role.data);
                this.$router.push({
                  name: "question",
                });
              });
            }
          }
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "",
          text: "ไม่พบข้อมูลในช่วงเวลาดังกล่าว",
          timer: 1500,
        });
      }
    },
    JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

      var CSV = "";
      //Set Report title in first row or line

      CSV += "ช่วงเวลา: " + this.ThaiDate(this.date) + "\r\n\n";

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row1 = "";

        //This loop will extract the label from 1st index of on array
        for (var index1 in arrData[0]) {
          //Now convert each value to string and comma-seprated
          row1 += index1 + ",";
        }

        row1 = row1.slice(0, -1);

        //append Label row with line break
        CSV += row1 + "\r\n";
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      //Generate a file name
      var fileName = "";
      //this will remove the blank-spaces from the title and replace it with an underscore
      fileName += ReportTitle.replace(/ /g, "_");

      //Initialize file format you want csv or xls
      var uri = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(CSV);

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension

      //this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.href = uri;

      //set the visibility hidden so it will not effect on your web-layout
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped></style>
